import { FormattedMessage } from "react-intl";
import { admin } from "./admin";

export const myQueries = {
  label: <FormattedMessage id="MY_QUERIES_TEXT" />,
  path: (tenantName) => `/${tenantName}/admin/myQuery`,
  viewPath: `/${localStorage.getItem("tenantName")}/admin/viewShotclass`,
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      // path: `${admin.path}`,
      // onClick: () => navigate(`${admin.path}`),
      path: admin.path(tenantName),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: myQueries.label,
      path: myQueries.path,
      // onClick: () => navigate(myQueries.path(tenantName)),
    },
  ],
};
